<div
	class="obg-feature-unavailable-container"
	test-id="page-unavailable-container"
	[style.background-image]="'url(' + (backgroundImageUrl$ | async) + ')'"
>
	<ng-content></ng-content>
	<span class="obg-feature-unavailable-container-header" test-id="page-unavailable-message" *ngIf="titleText"
		>{{ titleText | translate }}</span
	>
	<p *ngIf="caption">{{ caption | translate }}</p>

	<ul class="obg-feature-unavailable-links">
		<li
			class="obg-feature-unavailable-links-link"
			*ngFor="let quicklink of quickLinks$ | async; trackBy: trackByQuicklink"
		>
			<a [obgRouteLink]="{ url: quicklink.link.url }">
				<figure>
					<img [src]="quicklink.image?.url" [alt]="quicklink.image?.altText" />
					<figcaption>{{ quicklink.label.text }}</figcaption>
				</figure>
			</a>
		</li>
	</ul>
</div>
